var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavMenu',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"last",fn:function(){return [_c('b-nav-form',{staticClass:"ml-auto"},[_c('TypeaheadProjects',{staticStyle:{"min-width":"200px"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }